import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../";

export const selectSettings = (state: RootState) => state.settings;

export const selectSettingsPermissions = createSelector([selectSettings], (settings) => settings.permissions);

export const selectSettingsPermissionsMicrophone = createSelector([selectSettingsPermissions], (permissions) => permissions.microphone);

export const selectSettingsPermissionsCamera = createSelector([selectSettingsPermissions], (permissions) => permissions.camera);
